import React from 'react';

import styles from './SummaryInnerForm.module.scss';

const SummaryInnerForm = ({
  state,
  babyConnect,
  onClick,
  setCheckoutSection
}) => {
  return (
    <div className={styles.form}>
      <h2 className={styles.title}>Akkoord en betaling</h2>
      <div className={styles.summary}>
          <h3>Overzicht</h3>
        <div className={styles.row}>
          <div className={styles.item}>
            <span>{state.data.firstname} {state.data.lastname}</span>
            <span>{state.data.adres}</span>
            <span>{state.data.postal}</span>
          </div>
          <div className={styles.item}>
            <span>{state.data.email}</span>
            <span>{state.data.telephone}</span>
            <span>{state.data.telephonePartner}</span>
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.item}>
            <span>Verloskundige: {state.data.midwife}</span>
            <span>{state.data.maternity}</span>
            <span>Gevonden via {state.data.found || state.data.other}</span>
          </div>
          {!babyConnect && (
            <div className={styles.item}>
              <span>Datum: {state.data.pregDate}</span>
              <span>{state.data.pregCount}e zwangerschap</span>
            </div>
          )}
        </div>
      </div>
      <div className={styles.controls}>
        <button onClick={setCheckoutSection} className='button button--tertiary'>Terug</button>
        <button onClick={onClick} className='button'>Akkoord en doorgaan</button>
      </div>
    </div>
  )
}

export default SummaryInnerForm;